import { createTheme } from "@mui/material/styles";

export const MobileBookingsTheme = ({ palette, spacing }) =>
    createTheme({
        palette,
        typography: {
            body2: {
                color: palette.text.main,
                fontSize: "0.875rem"
            },
            h1: {
                fontSize: "24px"
            },
            link: {
                color: palette.primary.main,
                cursor: "pointer",
                fontSize: "14px",
                ":hover": {
                    textDecoration: "underline"
                }
            }
        },
        components: {
            MuiStack: {
                styleOverrides: {
                    root: {
                        flexDirection: "column",
                        gap: "18px",
                        margin: "4px"
                    }
                }
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)"
                    }
                }
            },
            MuiCardContent: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "9px",
                        padding: "18px 14px !important"
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        height: "36px",
                        width: "100%",
                        maxWidth: "400px",
                        fontSize: "14px",
                        textTransform: "capitalize !important",
                        fontWeight: 400,
                        color: palette.text.primary,
                        boxShadow: "none",
                        borderRadius: "16px",
                        border: "none",
                        "&:hover": {
                            border: "none"
                        }
                    },
                    text: {
                        color: palette.primary.main,
                        letterSpacing: "normal",
                        width: "fit-content",
                        fontWeight: "500",
                        textTransform: "none !important",
                        "&:hover": {
                            backgroundColor: "transparent"
                        }
                    },
                    pendingAction: {
                        color: "white",
                        borderRadius: "4px",
                        "&:hover": {
                            color: "white"
                        }
                    }
                }
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: palette.primary.main,
                        fontSize: "1rem"
                    }
                }
            },
            MuiFab: {
                styleOverrides: {
                    root: {
                        position: "fixed",
                        bottom: spacing(12),
                        right: spacing(2),
                        backgroundColor: palette.primary.main,
                        "&:hover": {
                            backgroundColor: palette.primary.main
                        }
                    }
                }
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        height: "24px"
                    }
                }
            }
        }
    });
